import Theme from '../../../theme';
import styled from 'styled-components';

export const Divider = styled.div`
  align-self: stretch;
  border-bottom: 2px solid ${Theme.colors.whiteSmoke.hexCode};
`;
